import { render, staticRenderFns } from "./ModalNewTicket.vue?vue&type=template&id=78a6c918&scoped=true&"
import script from "./ModalNewTicket.vue?vue&type=script&lang=js&"
export * from "./ModalNewTicket.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewTicket.vue?vue&type=style&index=0&id=78a6c918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6c918",
  null
  
)

export default component.exports